export const SUPPORTED_NUMBER_OF_SKUS = 1000;
export const SUPPORTED_NUMBER_OF_SKUS_FBA = 200;
export const REPLENISHMENT_TIMEOUT_MS = 30000;
export const TIMEOUT_MS = 15000;
export const MAX_FILE_SIZE = 2000 * 1000; // 2mb
export const SEP_CHARACTER = ",";
